import axios from 'axios'
import { AuthMethod } from '@/dto/AuthMethod'

class AuthorizationService {
  methods: AuthMethod[] = []

  types = {
    login: 'login',
    sms: 'sms',
    qr: 'qr',
  }

  async getMethods(): Promise<AuthMethod[]> {
    if (this.methods.length > 0) {
      return this.methods
    }

    return axios
      .get('/authorization-methods')
      .then(response => response.data.authorizationMethods)
  }
}

export default new AuthorizationService()
